<div
	class="fixed top-[100px] left-1/2 z-[9999] bg-accentColor text-white font-bold py-4 px-5 md:px-7 rounded-2xl shadow-xl transition-top md:w-auto w-4/5 text-sm md:text-base"
	[@errorState]="service.availabilityError.state"
>
	{{ service.availabilityError.message }}
</div>
